<template>
  <div class="content-wrapper">
    <app-page-top-section :title="$t('all_locations')" icon="briefcase">
      <app-default-button btn-class="btn btn-success mr-2"
                          :title="$fieldTitle('add', 'location', true)"
                          @click="openModal()"
                          v-if="$can('create_locations')"
      />
    </app-page-top-section>

    <app-table
        id="location-table"
        :options="options"
        :card-view="false"
        @getRows="getSelectedRows"
        @action="triggerActions"
    />

    <location-create-edit-modal
        v-if="isLocationCreateOpenModalActive || isModalActive"
        v-model="isModalActive"
        :selected-url="selectedUrl"
        @close="isModalActive = false"
    />

    <app-confirmation-modal
        v-if="confirmationModalActive"
        icon="trash-2"
        modal-id="app-confirmation-modal"
        @confirmed="confirmed('location-table')"
        @cancelled="cancelled"
    />

  </div>
</template>

<script>

import LocationMixin from "../../Mixins/LocationMixin";
import {axiosGet} from "../../../../common/Helper/AxiosHelper";
import LocationCreateEditModal from "./LocationCreateEditModal";
import {GET_ALL_LOCATIONS} from "../../../Config/ApiUrl";
import {Loader} from "@googlemaps/js-api-loader";

export default {
  components: {LocationCreateEditModal},
  mixins: [LocationMixin],
  data() {
    return {
      isModalActive: false,
      // locations: [],
    }
  },
  mounted() {
    // this.getLocations();
  },
  methods: {
    getLocations() {
      axiosGet(this.apiUrl.GET_ALL_LOCATIONS).then(({data}) => {
        console.log(data);
      })
    },
    triggerActions(row, action, active) {
      if (action.title === this.$t('edit')) {
        this.selectedUrl = `${GET_ALL_LOCATIONS}/${row.id}`;
        this.isModalActive = true;
      } else {
        this.getAction(row, action, active)
      }
    },
    openModal() {
      this.isModalActive = true;
      this.selectedUrl = ''
    },
  },
  computed: {},
  watch: {}
}
</script>